import React, { createContext, useState, useContext } from 'react';

const AppBarContext = createContext({
  setAppBarConfig: () => {},
  appBarConfig: {}
});

export const useAppBarContext = () => useContext(AppBarContext);


export const AppBarProvider = ({ children }) => {
  const [appBarConfig, setAppBarConfig] = useState({});

  const value = {
    setAppBarConfig,
    appBarConfig
  };

  return (
    <AppBarContext.Provider value={value}>
      {children}
    </AppBarContext.Provider>
  );
};

export default AppBarContext;